module.exports = "/static/assets/a45329a2542b590a54dba0ccd30fdf4e.gif";